import React, { Children } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from '@material-ui/core/DialogTitle';

export default React.memo(function AlertDialog({
  text = undefined,
  open = true,
  title,
  onClose,
  children,
  ok = 'بسیار خوب',
  variant = 'contained',
  color = 'secondary',
  fullWidth = false,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={fullWidth}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{text ? text : children}</DialogContent>
      <DialogActions>
        <Button type='submit' onClick={handleClose} color={color} variant={variant} autoFocus>
          {ok}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
